import { useSetAtom } from "jotai";

import {
  createContactAtom,
  hideAtom,
  loadCategoriesAtom,
  modeAtom,
  newContactAtom,
  resetAddressBookAtom,
  scrollToLetterAtom,
  searchQueryAtom,
  selectCategoryAtom,
  selectContactAtom,
  setAddressBookNameAtom,
  setOnChooserCallbackAtom,
  setSelectedCategoryAtom,
  setSelectedCategoryWithIndexAtom,
  setSelectedContactWithIdAtom,
  showAtom,
  toggleAtom,
  updateContactAtom,
  updateStickyLetterAtom,
} from "../stores";

/**
 * useSetAtom not rerenders the component when the atom's value changes,
 * so this hook will not cause unnecessary re-renders when the state updates.
 * It only provides the functions to manipulate the state.
 */
export const useAddressBookActions = () => {
  // Write state
  const createContact = useSetAtom(createContactAtom);
  const loadCategories = useSetAtom(loadCategoriesAtom);
  const selectCategory = useSetAtom(selectCategoryAtom);
  const selectContact = useSetAtom(selectContactAtom);
  const scrollToLetter = useSetAtom(scrollToLetterAtom);
  const resetAddressBook = useSetAtom(resetAddressBookAtom);
  const newContact = useSetAtom(newContactAtom);
  const updateContact = useSetAtom(updateContactAtom);
  const updateStickyLetter = useSetAtom(updateStickyLetterAtom);
  const setSearchQuery = useSetAtom(searchQueryAtom);

  // AddressBookHandle actions
  const show = useSetAtom(showAtom);
  const hide = useSetAtom(hideAtom);
  const toggle = useSetAtom(toggleAtom);
  const setMode = useSetAtom(modeAtom);
  const setAddressBookName = useSetAtom(setAddressBookNameAtom);
  const setOnChooserCallback = useSetAtom(setOnChooserCallbackAtom);
  const setSelectedContactWithId = useSetAtom(setSelectedContactWithIdAtom);
  const setSelectedCategoryWithIndex = useSetAtom(
    setSelectedCategoryWithIndexAtom,
  );
  const setSelectedCategory = useSetAtom(setSelectedCategoryAtom);

  return {
    // Writers
    createContact,
    loadCategories,
    selectCategory,
    selectContact,
    scrollToLetter,
    resetAddressBook,
    updateStickyLetter,
    newContact,
    updateContact,
    setSearchQuery,

    // AddressBookHandle actions
    show,
    hide,
    toggle,
    setMode,
    setAddressBookName,
    setOnChooserCallback,
    setSelectedContactWithId,
    setSelectedCategoryWithIndex,
    setSelectedCategory,
  };
};
